<template>
  <v-layout row class="widget--header pt-1 pb-2 pl-3 pr-1">
    <v-flex grow
      ><h3
        v-if="!hideTitle"
        class="pt-2 text-truncate text-align-left primary--text"
      >
        {{ title }}
      </h3>
    </v-flex>
    <v-flex shrink>
      <span class="widget-interval" v-if="interval">{{interval}}</span>
      <v-menu
        nudge-top="30px"
        left
        offset-y
        origin="center center"
        transition="scale-transition"
      >
        <v-btn
          flat
          slot="activator"
          icon
          class="ma-0 mr-0 pa-0"
          dark
          color="secondary"
        >
          <v-icon>more_vert</v-icon>
        </v-btn>

        <v-list dense>
          <v-list-tile @click.stop="goFullScreen()">
            <v-icon class="mr-2" color="secondary">fullscreen</v-icon>View Fullscreen
          </v-list-tile>
          <v-list-tile @click.stop="viewData()">
            <v-icon class="mr-2" color="secondary">list_alt</v-icon>View Data
          </v-list-tile>
          <v-list-tile @click.stop="configueWidget()">
            <v-icon class="mr-2" color="secondary">settings</v-icon>Configure
            Widget
          </v-list-tile>
          <v-list-tile @click.stop="confirmDelete()">
            <v-icon class="mr-2" color="secondary">delete</v-icon>Delete Widget
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-flex>
    <confirmation-dialog
      title="Delete Widget"
      message="Are you sure you want to delete this widget? The underlying data won't be deleted."
      confirmButtonLabel="Yes, delete this widget"
      :showDialog="showDeleteDialog"
      v-on:confirm="deleteMetric()"
      v-on:cancel="cancelDelete()"
    ></confirmation-dialog>
    <add-widget-dialog
      :widgetDialog="showConfigureDialog"
      v-on:new-widget-cancelled="closeForm()"
      v-on:new-widget-added="closeForm()"
      :widget="widget"
    ></add-widget-dialog>
  </v-layout>
</template>

<script>
import ConfirmationDialog from "@/components/shared/ConfirmationDialog.vue";
import AddWidgetDialog from "./AddWidgetDialog.vue";
import Vue from "vue"

export default {
  name: "WidgetHeader",
  components: { ConfirmationDialog, AddWidgetDialog },
  props: {
    widget: {
      type: Object,
      required: true,
    },
    hideTitle: {
      type: Boolean,
    },
    hideFullScreen: {
      type: Boolean
    }
  },
  computed: {
    title() {
      return this.widget.metric.name;
    },
    interval() {
      if (this.widget.timeInterval==='day') {
        return "Daily"
      } else if (this.widget.timeInterval==='week') {
        return "Weekly"
      } else if (this.widget.timeInterval==='month') {
        return "Monthly"
      }
    }
  },
  methods: {
    goFullScreen() {
      this.$emit('fullscreen', this.widget)
    },
    closeForm() {
      this.showConfigureDialog = false;
    },
    configueWidget() {
      this.showConfigureDialog = true;
    },
    confirmDelete() {
      this.showDeleteDialog = true;
    },
    cancelDelete() {
      this.showDeleteDialog = false;
    },
    deleteMetric() {
      this.showDeleteDialog = false;
      this.$store.dispatch("deleteWidget", this.widget);
    },
    viewData() {
      Vue.router.push({ name: "Bucket", params: { case_type_id: this.widget.metric.caseTypeId, bucket_id: this.widget.metric.bucketId } })
    }
  },
  data: () => {
    return {
      widgetDialogFullscreen: false,
      showDeleteDialog: false,
      showConfigureDialog: false,
    };
  },
};
</script>

<style>
.widget-interval {
  background-color: #faaa2a;
  color: white;
  padding: 5px;
}
</style>